// extracted by mini-css-extract-plugin
export default {"icon":"jEErsf","left":"OWxyuE"};